import React, { useRef } from "react";
import { TieredMenu } from "primereact/tieredmenu";
import styles from "./toggle-actions.module.css";

const ToggleActions = ({ menu, actions, btn }) => {
  menu = useRef(null);

  return (
    <>
      <TieredMenu model={actions} popup ref={menu} />
      <button
        type="button"
        onClick={(e) => menu.current.toggle(e)}
        className={`btn ${btn.class} ${btn.icon ? styles.settings : ""}`}
      >
        {btn.label ? btn.label : btn.icon}
      </button>
    </>
  );
};

export default ToggleActions;
